import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BookingPersonModel } from '../models/booking-person.model';
import { BaseService } from './base-service.service';

@Injectable({
  providedIn: 'root'
})
export class BookingPersonService  extends BaseService<BookingPersonModel>{

  constructor(http: HttpClient) {
    super(http, `${environment.apiUrl}api/BookingPerson`);
  }
  
  GetBookingPersonByDocNumber(docNumber: string, docType: string): Observable<BookingPersonModel[]> {
    return this.http.get<BookingPersonModel[]>(`${this.backUrl}/Query?filter=DocumentNumber eq '${docNumber}' and DocumentType eq '${docType}'`);
  }
}
